import { getSlugValue } from 'utilities';

export const FUND_INVESTMENTS_DOCUMENTS_TITLE = 'Documents';
export const FUND_INVESTMENTS_DOCUMENTS_SLUG = getSlugValue(FUND_INVESTMENTS_DOCUMENTS_TITLE);
